export interface ReviewComment {
  text: string
  createdAt: string | null
}

/** Presentation only: the label's original notes remain the stored feedback. */
export function reviewComments(notes: string): ReviewComment[] {
  const comments: ReviewComment[] = []
  const footer = /\nReviewed (\d{4}-\d{2}-\d{2}T[\d:.]+) UTC(?=\n\n|$)/g
  let start = 0
  for (const match of notes.matchAll(footer)) {
    const value = match[1]
    if (value === undefined) throw new Error('Review timestamp capture is missing')
    const stamp = `${value}Z`
    if (Number.isNaN(new Date(stamp).getTime())) continue
    let body = notes.slice(start, match.index).trim()
    const lines = body.split('\n')
    let boundary = lines.length
    while (boundary > 0 && lines[boundary - 1]?.startsWith('> ')) boundary -= 1
    if (boundary < lines.length) {
      const legacy = lines.slice(0, boundary).join('\n').trim()
      if (legacy !== '') comments.push({ text: legacy, createdAt: null })
      body = lines.slice(boundary).map((line) => line.slice(2)).join('\n')
    }
    const verdict = /^(Good|Bad)(?::\s*|$)/.exec(body)
    comments.push({
      text: verdict === null ? body : body.slice(verdict[0].length),
      createdAt: stamp,
    })
    start = match.index + match[0].length
  }
  const remaining = notes.slice(start).trim()
  if (remaining !== '') comments.push({ text: remaining, createdAt: null })
  return comments
}
